import classNames from 'classnames'
import type { FC } from 'react'
import React from 'react'

import { useCardContext } from './card-context'
import CardTitle from './card-title'
import type { CardHeaderProps } from './types'
import { GridPrivate } from '../_layouts/grid/grid'
import { FlexPrivate } from '../_primitives/flex/flex'

const CardHeader: FC<CardHeaderProps> = ({
  variant = 'header',
  className,
  title,
  children,
  display,
  titleProps,
  ...props
}) => {
  const { variant: cardVariant } = useCardContext()
  return display === 'grid' ? (
    <GridPrivate
      __themeKey="cards"
      variant={cardVariant ? `${cardVariant}.header` : variant}
      className={classNames({ 'csg-tui-card-header-grid': true }, className)}
      {...props}
    >
      {title ? <CardTitle {...titleProps}>{title}</CardTitle> : children}
    </GridPrivate>
  ) : (
    <FlexPrivate
      __themeKey="cards"
      variant={cardVariant ? `${cardVariant}.header` : variant}
      className={classNames(
        {
          'csg-tui-card-header': true
        },
        className
      )}
      {...props}
    >
      {title ? <CardTitle {...titleProps}>{title}</CardTitle> : children}
    </FlexPrivate>
  )
}

export default CardHeader
